<template>
  <v-dialog
    v-model="isShow"
    :content-class="
      isShow
        ? 'elevation-0 d-flex'
        : '' + !$vuetify.breakpoint.xs
        ? 'height90'
        : ''
    "
    :fullscreen="$vuetify.breakpoint.xs"
    @input="updateShowLogIn"
    max-width="500"
  >
    <v-card>
      <v-icon
        v-if="$vuetify.breakpoint.xs"
        class="float-right"
        color="grey"
        @click="closeLogIn"
        style="top: 8px; right: 8px"
        >mdi-close</v-icon
      >
      <div class="card-content text-center">
        <v-img
          class="ma-auto cursor-pointer"
          src="@/assets/image/ticketplus-logo.svg"
          max-width="27%"
          contain
        />
        <div class="loginPadding py-5">
          <div class="mt-8">
            <v-form
              v-model="isFormValid"
              @submit.prevent="login"
              autocomplete="off"
              ref="loginForm"
            >
              <VuePhoneNumberInput
                class="mb-4"
                required
                size="lg"
                color="#8d8d8d"
                valid-color="#379cc4"
                :no-flags="true"
                :error-color="'#ff0032'"
                :error="isPhoneNumberError"
                :translations="{
                  countrySelectorLabel: $t('country_code'),
                  phoneNumberLabel: $t('login_phone_field'),
                  example: $t('phone_number_example')
                }"
                :no-example="true"
                v-model="phoneNumberWithCode"
                @update="phoneNumberUpdate"
                @phone-number-blur="phoneNuberBlur"
              />
              <div class="v-text-field__details pl-3">
                <div class="v-messages theme--light error--text" role="alert">
                  <div class="v-messages__wrapper">
                    <div
                      v-if="isShowPhoneNumberWarning"
                      class="v-messages__message"
                    >
                      {{ $t("input_required") }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="country !== 'TW'"
                class="v-alert p-4 text-left red--text pink-1 body-2 font-weight-regular rounded-lg"
                v-html="$t('mobile_hint')"
              ></div>
              <v-text-field
                class="mt-2"
                v-model="password"
                ref="password"
                :label="$t('login_password_field')"
                :hint="$t('login_password_field_validation')"
                autocomplete="new-password"
                outlined
                color="primary-1"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[inputRules.required]"
                :type="showPassword ? 'text' : 'password'"
                @click:append="showPassword = !showPassword"
                @input="inputField"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>
              </v-text-field>
              <div class="mb-2 red--text">
                {{ errorMessage }}
              </div>

              <div
                class="text-right text-small cursor-pointer"
                @click="toForgetPassword"
              >
                {{ $t("login_forget_password") }}
              </div>

              <v-btn
                class="nextBtn mt-2"
                :class="{
                  disabledBtn:
                    !isFormValid || loadingLogin || isPhoneNumberError
                }"
                :disabled="!isFormValid || loadingLogin || isPhoneNumberError"
                block
                depressed
                x-large
                type="submit"
                color="white"
              >
                <template v-if="loadingLogin">
                  <v-progress-circular
                    indeterminate
                    color="white"
                    size="25"
                    width="2"
                  ></v-progress-circular>
                </template>
                <template v-else> {{ $t("login_cta") }} </template>
              </v-btn>
            </v-form>
          </div>

          <div class="mt-8 font-weight-bold text-small">
            {{ $t("login_not_member")
            }}<span
              role="button"
              class="primary-1--text font-weight-bold"
              @click="toRegister"
              >{{ $t("login_register") }}</span
            >
          </div>
        </div>
      </div>
    </v-card>
    <div
      v-if="!$vuetify.breakpoint.xs"
      class="float-out-close-btn"
      @click="closeLogIn"
    >
      <v-icon color="white" @click="closeLogIn">mdi-close</v-icon>
    </div>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UM from "@/api/user-management";
import inputRulesJS from "@/shared/inputRules.js";
import jwt_decode from "jwt-decode";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  components: {
    VuePhoneNumberInput
  },
  data() {
    return {
      isFormValid: false,
      phoneNumberWithCode: "",
      country: "",
      countryCode: "",
      mobile: "",
      password: "",
      showPassword: false,
      inputRules: {
        required: inputRulesJS.required
      },
      loadingLogin: false,
      errorMessage: "",
      isPhoneNumberError: false,
      isShowPhoneNumberWarning: false
    };
  },
  computed: {
    ...mapGetters({
      showLogin: "login/showLogin"
    }),
    isShow: {
      get() {
        return this.$store.getters["login/showLogin"];
      },
      set(newVal) {
        if (!newVal) this.closeLogIn;
        else this.showLogIn();
      }
    },
    accountValid() {
      if (this.mobile) return [];
    }
  },
  watch: {
    isShow(newVal, old) {
      if (newVal) {
        this.getCountryCode();
      }
    },
    showLogin: {
      deep: true,
      async handler(newVal) {
        if (newVal && this.$route.name === "register") {
          this.$router
            .push({
              name: "Index"
            })
            .catch(error => {});
        }
      }
    }
  },
  methods: {
    ...mapActions({
      closeLogIn: "login/close",
      relogin: "login/relogin",
      showLogIn: "login/show",
      storeLogin: "user/login"
    }),
    getCountryCode() {
      const countrySelect = document.querySelector(".country-selector__input");

      if (!countrySelect) {
        setTimeout(() => {
          this.getCountryCode();
        }, 300);

        return;
      }
      this.countryCode = countrySelect.value.replaceAll("+", "");
    },
    updateShowLogIn(val) {
      if (!val) {
        this.closeLogIn();
      }
    },
    getTime() {
      function pad2(n) {
        return n < 10 ? "0" + n : n;
      }
      let date = new Date();
      return (
        date.getFullYear().toString() +
        pad2(date.getMonth() + 1) +
        pad2(date.getDate()) +
        pad2(date.getHours()) +
        pad2(date.getMinutes()) +
        pad2(date.getSeconds())
      );
    },
    async login(f) {
      this.loadingLogin = true;
      // console.log("login");
      const { data: loginRes } = await UM.login(
        this.countryCode,
        this.mobile.replaceAll(/\D/g, ""),
        this.password
      );
      this.loadingLogin = false;
      this.relogin(false);
      // console.log(`${String.fromCodePoint(128049)} [UM] login`, loginRes);
      if (loginRes.errCode == "00") {
        // store res in vuex user state
        this.storeLogin({ account: this.mobile, ...loginRes.userInfo });
        this.$refs.loginForm.reset();
        this.closeLogIn();

        let decodeToken = jwt_decode(loginRes.userInfo.access_token);
        let currentTime = this.getTime();
        // let params = new FormData();
        // params.append("ctid", getCtIdData.cd);
        // params.append("uid", decodeToken.id);
        // params.append("login_time", currentTime);
        // params.append("chnl", "ticketplus");
        // ga tracking event
        this.$gtm.trackView("Login", this.$route.path);
      } else {
        this.mobile = "";
        this.phoneNumberWithCode = "";
        this.password = "";
        this.$refs.password.resetValidation();
        this.errorMessage = this.$t("login_submit_error");
      }
    },
    toForgetPassword() {
      this.closeLogIn();
      this.$router.push({ name: "ForgotPassword" }).catch(() => {});
    },
    toRegister() {
      this.closeLogIn();
      this.$router.push({ name: "register" }).catch(() => {});
    },
    inputField() {
      this.errorMessage = "";
    },
    phoneNuberBlur() {
      if (!this.phoneNumberWithCode) {
        this.isPhoneNumberError = true;
        this.isShowPhoneNumberWarning = true;
      }
    },
    phoneNumberUpdate(phoneNumberObject) {
      this.mobile = phoneNumberObject?.phoneNumber || "";
      this.countryCode = phoneNumberObject?.countryCallingCode || "";
      this.country = phoneNumberObject?.countryCode || "";
      let isValidHK = true;
      // UI 定義的特殊行為，當初始顯示時不要檢查是否錯誤，維持元件的框為黑色，
      // 但是元件 init 後顯示時會自動呼叫 updatd event，導致初始顯示時就會當成驗證失敗的狀態，
      // bypass 沒輸入電話時的檢查行為
      if (phoneNumberObject?.countryCode === "HK") {
        let num = phoneNumberObject?.phoneNumber.replace(" ", "");
        isValidHK = /^([4|5|6|7|8|9])\d{7}$/.test(num);
      }
      if (
        this.phoneNumberWithCode === "" &&
        phoneNumberObject?.phoneNumber === undefined
      ) {
        return;
      }

      if (
        !this.mobile ||
        (phoneNumberObject?.isValid === false && !isValidHK)
      ) {
        this.isPhoneNumberError = true;
      } else {
        this.isPhoneNumberError = false;
      }
      if (phoneNumberObject?.phoneNumber === undefined) {
        this.isShowPhoneNumberWarning = true;
      } else {
        this.isShowPhoneNumberWarning = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card-content {
  width: 440px;

  margin: auto;
  padding: 32px 0;

  @media screen and (max-width: 600px) {
    width: unset;
    padding: 100px 0;
  }

  @media screen and (max-width: 480px) {
    height: auto;
    min-height: 100%;
  }

  @media screen and (max-width: 375px) {
    width: unset;
    padding: 60px 0;
  }
}

@media screen and (max-width: 480px) {
  .v-dialog.v-dialog--fullscreen > .v-sheet.v-card {
    position: absolute;
    width: 100%;
  }
}

.float-out-close-btn {
  width: 24px;
  // position: absolute;
  // top: 5px;
  // right: -30px;
}

.v-icon.v-icon::after {
  content: unset;
}

.loginPadding {
  padding: 0 50px;

  @media screen and (max-width: 600px) {
    padding: 0px 30px;
  }
}
</style>
